import React from "react"

import SuperadminContainer from "features/Superadmin/containers/Superadmin.container"

const Superadmin: React.FC = () => {
  return (
    <>
      <title>DATA(Q) - Superadmin Panel</title>
      <SuperadminContainer />
    </>
  )
}

export default Superadmin
